

/**
 * @name ShopHours
 * @description The shop hours service
 * @param {type} $q Description
 * @param {type} $http Description
 * @param {type} $interval Description
 * @param {type} $rootScope Description
 * @param {type} ENDPOINT Description
 * @param {type} ScheduleUtilFactory Description
 * @param {type} moment Description
 * @param {type} AlertMessages Description
 * @param {type} Session Description
 * @param {library} _ The Lodash library
 * @return {type} Description
 */
function ShopHours(
  $q,
  $http,
  $interval,
  $rootScope,
  ENDPOINT,
  ScheduleUtilFactory,
  moment,
  AlertMessages,
  Session,
  _
) {
  ShopHours.get = get;
  ShopHours.refresh = refresh;
  ShopHours.expire = expire;
  ShopHours.parse = parse;
  ShopHours.create = create;
  ShopHours.update = update;
  ShopHours.process = process;
  ShopHours.getHoursByDay = getHoursByDay;

  // The object holding all variables relating to queries
  let qwe;

  resetvariables();

  /**
   * @name resetvariables
   * @description description
   */
  function resetvariables() {
    qwe = {
      shopHours: {}
    };

    ShopHours.shopHours = {};
    ShopHours.allShopHours = [];
  }

  // Called to Reset Data on Logout
  let deregister = $rootScope.$on('clear-data', function() {
    $interval.cancel(qwe.shopHours.timer);
    resetvariables();
  });
  $rootScope.$on('$destroy', deregister);

  /**
   * @name createShopHourTimer
   * @description description
   * @param {number} shopId The ID of the shop
   */
  function createShopHourTimer(shopId) {
    if (!qwe.shopHours.timer) {
      qwe.shopHours.timer = $interval(function() {
        makeNewShopHoursPromise(shopId);
      }, 1000);
    }
  }

  /**
   * @name makeNewShopHoursPromise
   * @description description
   * @param {number} shopId The ID of the shop
   */
  function makeNewShopHoursPromise(shopId) {
    if (!shouldRefresh()) {
      return;
    }
    qwe.shopHours.override = false;
    qwe.shopHours.promise = $q(function(resolve, reject) {
      qwe.shopHours.refreshing = true;
      $http.get(ENDPOINT.server +
      'schedules/api/v1.1/shop-hours/all/?shop_id=' + shopId)
      .then(function(response) {
        if (qwe.shopHours.timer) {
          parse(response.data);
          ShopHours.allShopHours = response.data;

          let activeRules = [];
          for (let i = 0; i < ShopHours.allShopHours.length; i++) {
            let hour = ShopHours.allShopHours[i];
            if (hour && !hour.end_date) {
              activeRules.push(hour);
            }
          }
          ShopHours.shopHours = activeRules;
          qwe.shopHours.updated = moment();
          resolve({all: ShopHours.allShopHours, current: activeRules});
        }
        qwe.shopHours.refreshing = false;
      }, function(error) {
        reject(error);
      });
    });
  }

  /**
   * @name shouldRefresh
   * @description description
   * @return {boolean} Description
   */
  function shouldRefresh() {
    return qwe.shopHours.override || (!qwe.shopHours.refreshing &&
    (!qwe.shopHours.updated || moment()
    .diff(qwe.shopHours.updated, 'seconds') >= 23));
  }

  /**
   * @name get
   * @description Function to get shop hours
   * @param {number} shopId The ID of the shop
   * @return {object} Unknown
   */
  function get(shopId) {
    createShopHourTimer(shopId);
    makeNewShopHoursPromise(shopId);
    return qwe.shopHours.promise;
  }

  /**
   * @name refresh
   * @description description
   * @return {function} Description
   */
  function refresh() {
    qwe.shopHours.override = true;
    return get();
  }

  /**
   * @name create
   * @description Create new shops hours
   * @param {type} shopHours Description
   * @return {type} Description
   */
  function create(shopHours) {
    // Some Preprocessing
    ScheduleUtilFactory.daysToBoolean(shopHours);
    packageHoursData(shopHours);

    let url = ENDPOINT.server + 'schedules/api/v1.1/shop-hours/create/';

    return $http.post(url, shopHours)
    .then(function(response) {
      return response.data;
    }, function(error) {
      throw error;
    });
  }

  /**
   * @name update
   * @description Function to update existing shop hours
   * @param {type} shopHours Description
   * @return {type} Description
   */
  function update(shopHours) {
    let url = ENDPOINT.server + 'schedules/api/v1.1/shop-hours/';

    // Some Preprocessing
    ScheduleUtilFactory.daysToBoolean(shopHours);
    packageHoursData(shopHours);

    return $http.post(url, shopHours)
    .then(function(response) {
      return response.data;
    }, function(error) {
      throw error;
    });
  }

  /**
   * @name process
   * @description description
   * @param {type} data Description
   * @return {type} Description
   */
  function process(data) {
    let processed = data;

    // Convert time to 12hr Format.
    processed.start_time = moment(data.start_time, 'HH:mm:ss');
    processed.end_time = moment(data.end_time, 'HH:mm:ss');

    if (!processed.selected_days) {
      ScheduleUtilFactory.booleansToDays(processed);
      ScheduleUtilFactory.daysToText(processed);
    }
    return processed;
  }

  /**
   * @name getHoursByDay
   * @description description
   * @param {type} date Description
   * @return {type} Description
   */
  function getHoursByDay(date) {
    let selected_day = moment(date, 'YYYY/MM/DD').format('dddd');
    let selected_hour_set;

    _.each(ShopHours.shopHours, function(hour_set) {
      let days = [];
      if (hour_set.is_sunday) {
        days.push('Sunday');
      }
      if (hour_set.is_monday) {
        days.push('Monday');
      }
      if (hour_set.is_tuesday) {
        days.push('Tuesday');
      }
      if (hour_set.is_wednesday) {
        days.push('Wednesday');
      }
      if (hour_set.is_thursday) {
        days.push('Thursday');
      }
      if (hour_set.is_friday) {
        days.push('Friday');
      }
      if (hour_set.is_saturday) {
        days.push('Saturday');
      }

      _.each(days, function(day) {
        if (selected_day === day) {
          selected_hour_set = hour_set;
        }
      });
    });

    return selected_hour_set;
  }

  /**
   * @name parse
   * @description description
   * @param {type} hours Description
   */
  function parse(hours) {
    for (let i = 0; i < hours.length; i++) {
      let hour = hours[i];

      hour.start = moment(hour.start_date + 'T' + hour.start_time);
      // Not necessarily when the first instance of the rule is, it may not take place on that day
      hour.first_sunday = moment(hour.start).startOf('week');

      ScheduleUtilFactory.booleansToDays(hour);

      if (hour.end_date) {
        hour.end = moment(hour.end_date + 'T' + hour.end_time); // Not necessarily when the last instance of the rule is, it may not take place on that day
      }

      hour.original = {
        id: hour.id,
        selectedDays: hour.days,
        startTime: moment(hour.start_time, 'HH:mm:ss'),
        endTime: moment(hour.end_time, 'HH:mm:ss'),
        startDate: moment(hour.start_date, 'YYYY-MM-DD').startOf('day')
      };

      if (hour.end) {
        hour.original.endDate = moment(hour.end).startOf('day');
      }

      hour.display = {
        selectedDays: hour.days,
        startTime: hour.original.startTime.format('h:mm a'),
        endTime: hour.original.endTime.format('h:mm a')
      };

      hour.update = _.cloneDeep(hour.original);
    }
  }

  /**
   * @name expire
   * @description Pre-canned method of Expiring the Shop Hour Set
   * @param {type} hoursData Description
   * @return {type} Description
   */
  function expire(hoursData) {
    let shopHours = _.cloneDeep(hoursData.original);

    ScheduleUtilFactory.daysToBoolean(shopHours);
    packageHoursData(shopHours);

    if (moment(hoursData.start_time, 'HH:mm:ss').unix() >
    moment(hoursData.end_time, 'HH:mm:ss').unix()) {
      shopHours.end_date = moment().format('YYYY-MM-DD');
    } else {
      shopHours.end_date = moment().subtract(1, 'day').format('YYYY-MM-DD');
    }
    let url = ENDPOINT.server + 'schedules/api/v1.1/shop-hours/';
    return $http.post(url, shopHours)
    .then(function(response) {
      return response.data;
    }, function(error) {
      throw error;
    });
  }

  /**
   * @name packageHoursData
   * @description Format for Sending
   * @param {type} shopHours Description
   */
  function packageHoursData(shopHours) {
    shopHours.shop_hour_id = shopHours.id;
    shopHours.start_time = moment(shopHours.startTime).format('HH:mm:ss');
    shopHours.end_time = moment(shopHours.endTime).format('HH:mm:ss');
    shopHours.start_date = moment(shopHours.startDate).format('YYYY-MM-DD');
    shopHours.interval = 1;
    shopHours.selected_days = shopHours.selectedDays;
    shopHours.association_id = Session.activeState.association.id;
  }
  return ShopHours;
}

angular
  .module('inkfinder')
  .factory('ShopHours', ShopHours);



// WEBPACK FOOTER //
// ./components/shop/hours/shop-hours.service.js